import { render, staticRenderFns } from "./CDRsManagerLandingPage.vue?vue&type=template&id=1dbd0510&"
import script from "./CDRsManagerLandingPage.vue?vue&type=script&lang=js&"
export * from "./CDRsManagerLandingPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports